module.exports = __webpack_public_path__ + "static/media/How to change Display Email address for Social MediaWebsite.36600a0a.png";